import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const flowSteps = [
  { icon: FiIcons.FiHardDrive, label: 'Bare Metal Genesis', sub: 'Local Medallion Minting', color: 'cyan' },
  { icon: FiIcons.FiCopy, label: 'Doppelganger Sandbox', sub: 'Zero-PII Local Verification', color: 'amber' },
  { icon: FiIcons.FiKey, label: 'Hammurabi Handoff', sub: 'Cryptographic Escrow Contract', color: 'fuchsia' },
  { icon: FiIcons.FiDatabase, label: 'Eduba Query Cache', sub: 'Federated Corporate Access', color: 'emerald' },
];

export default function EscrowFlow() {
  return (
    <div className="space-y-3">
      {flowSteps.map((step, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.15 }}
          className="relative"
        >
          {i < flowSteps.length - 1 && (
            <div className="absolute left-6 top-full w-px h-3 bg-zinc-800" />
          )}
          <div className="flex items-start gap-4 p-4 bg-zinc-900/30 border border-zinc-800/50 rounded-lg hover:border-zinc-700 transition-all">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center border border-${step.color}-500/40 bg-${step.color}-500/10 flex-shrink-0`}>
              <SafeIcon icon={step.icon} className={`text-lg text-${step.color}-400`} />
            </div>
            <div className="flex-1">
              <div className={`text-xs font-bold tracking-widest uppercase text-${step.color}-400 mb-1`}>
                {step.label}
              </div>
              <div className="text-[10px] text-zinc-500 font-mono">{step.sub}</div>
            </div>
            <SafeIcon icon={FiIcons.FiChevronRight} className="text-zinc-700 text-lg" />
          </div>
        </motion.div>
      ))}
    </div>
  );
}